<template>
    <div class="clients">

        <div class="clients__title">
            Statistiques avancées
        </div>

        <div class="clients__subtitle">
            Recherche statistiques avancées
        </div>

        <StatisticsAssistanceCustomFilter :filters="filters"
                                @getGarantiesWithFilters="getGaranties"
                                @garantiesDownloadCSV="downloadReport('csv')"
                                @garantiesDownloadXLSX="downloadReport('xlsx')"
        />
      <template v-if="isBusy">
        <Preloader/>
      </template>
      <template v-else>
        <div class="block__content--table ">
          <table>
            <thead>
            <tr>
              <th>Date</th>
              <th>Nom</th>
              <th>Garantie souscrite</th>
              <th>Prix</th>
              <th v-if="!isDealer()">Category</th>
              <th>PDF</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="garanty in garantiesSouscrites.data">
              <td>{{parseDate(garanty)}}</td>
              <td>{{parseFullName(garanty)}}</td>
              <td>{{parseTypeGaranty(garanty)}}</td>
              <td>{{parsePrice(garanty) | formatSeparateComma}}</td>
              <td v-if="!isDealer()">{{parseCategoryGaranty(garanty)}}</td>
              <td class="pdf-icon">
                <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_pdf(garanty.id)"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <pagination :data="garantiesSouscrites" :limit="5" @pagination-change-page="getGaranties"></pagination>
      </template>
    </div>
</template>

<script>
    import StatisticsAssistanceCustomFilter from '@/components/Statistics/StatisticsAssistanceCustomFilter';
    import Preloader from '@/components/Preloader';
    import pdfPreviewMixin from '../../mixins/pdfPreviewMixin';
    import {CLIENT_CIVILITY} from "../../constants/client";

    export default {
        name: 'AdvanceStatsAssistance',
        components: {StatisticsAssistanceCustomFilter, Preloader},
        mixins: [pdfPreviewMixin],
        data() {
            return {
                garantiesSouscrites: {
                  data: []
                },
                filters: {
                    start_date: null,
                    end_date: null,
                    full_name: '',
                    min_amount: 0,
                    registration: '',
                    mechanic_garage: '',
                    categories: {
                      vp_vu_4x4: {value: false, id: 2},
                      camping_car: {value: false, id: 1},
                      moto: {value:false, id: 3},
                    },
                  //Standard, Réseau, Maxi-Réseau, Maxi Plus, Prestige, Complète
                    garantie_types: {
                      autocar: {value: false, id: '1'},
                      poids_lourds: {value: false, id: '2'},
                      taxi: {value: false, id: '3'},
                      vl_vu: {value: false, id: '4'},
                      prestige: {value: false, id: 'prestige'},
                      complete: {value: false, id: 'complete'}
                    },
                  //custom dates & periods
                    periods: {
                      today: {value: false, id: 'today'},
                      yesterday: {value: false, id: 'yesterday'},
                      this_week: {value: false, id: 'this_week'},
                      last_week: {value: false, id: 'last_week'},
                      this_month: {value: false, id: 'this_month'},
                      last_month: {value: false, id: 'last_month'},
                      this_year: {value: false, id: 'this_year'},
                      last_year: {value: false, id: 'last_year'}
                    }
                },
                isBusy: true,
                filterParams: {
                    pdf: 1,
                },
                sortParams: {
                    sort: 'id|desc',

                },
            }
        },
        computed: {
            mechanic_id() {
                return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
            },
            representative_id() {
              return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
            },
        },
        methods: {
            isDealer() {
              return this.$store.getters.isDealer;
            },
            isRepresentative() {
              return this.$store.getters.isRepresentative;
            },
            getGaranties(page = 1) {
                // console.log('== getGaranties [stats] ==');
                this.isBusy = true;
                let url = 'garantie/assistance-search-stats?page=' + page,
                  data = {
                    ...this.filterParams,
                    ...this.sortParams,
                    ...this.getFilters(),
                  };
                if (this.isRepresentative()) {
                  url = 'garantie/representative-search-stats?page=' + page;
                  data['representative_id'] = this.representative_id;
                }

                else {
                  url = 'garantie/assistance-search-stats?page=' + page;
                  data['mechanic_id'] = this.mechanic_id;
                }

                this.apiGet(url, data)
                    .then(response => {
                        this.garantiesSouscrites = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally( () => {
                        this.isBusy = false;
                    })
            },
            downloadReport(type) {
                // console.log(`== downloadReport [stats] ${type} ==`);
                let url = 'garantie/stats-download';
                if (this.isRepresentative()) {
                  url = `garantie/representative-stats-download`;
                  window.location = this.getApiAuthUrl(url) + `&` + this.prepareDataForURL() + `&representative_id=${this.representative_id}&type=${type}`;
                }
                else if (this.isDealer()) {
                  url = `garantie/dealer-stats-download`;
                  window.location = this.getApiAuthUrl(url) + `&` + this.prepareDataForURL() + `&mechanic_id=${this.mechanic_id}&ownerType=dealer&type=${type}`;
                }
                else {
                  url = `garantie/stats-download`;
                  window.location = this.getApiAuthUrl(url) + `&` + this.prepareDataForURL() + `&mechanic_id=${this.mechanic_id}&ownerType=mechanic&type=${type}`;
                }
            },
            prepareDataForURL() {
              let pairs = [];
              let filters = this.getFilters();
              for (let i in filters) {
                if (['periods', 'duration', 'garantie', 'categories'].includes(i) && (filters[i].length > 0)) {
                  pairs.push(`${i}[]=` + encodeURIComponent(filters[i]));
                }
              }
              this.filters.start_date ? pairs.push(`start_date=${this.filters.start_date}`) : '';
              this.filters.end_date ? pairs.push(`end_date=${this.filters.end_date}`) : '';
              this.filters.full_name ? pairs.push(`full_name=${this.filters.full_name}`) : '';
              this.filters.min_amount ? pairs.push(`price=${this.filters.min_amount}`) : '';
              this.filters.registration ? pairs.push(`registration=${this.filters.registration}`) : '';
              this.representative_id  && this.filters.mechanic_garage ? pairs.push(`mechanic_garage=${this.filters.mechanic_garage}`) : '';

              return  pairs.join('&');
            },
            getFilters() {
                let data = {};
                this.filters.start_date ? data.start_date = this.filters.start_date : '';
                this.filters.end_date ? data.end_date = this.filters.end_date : '';
                this.filters.full_name ? data.full_name = this.filters.full_name : '';
                // this.filters.category ? data.category = this.filters.category : '';
                this.filters.min_amount ? data.price = this.filters.min_amount : 0;
                this.filters.registration ? data.registration = this.filters.registration : '';
                this.representative_id  && this.filters.mechanic_garage ? data.mechanic_garage = this.filters.mechanic_garage : null;
                if (this.filters.categories) {
                  data.categories = [];
                  for (let i in this.filters.categories) {
                    let category = this.filters.categories[i];
                    if (category.value) { data.categories.push(category.id); }
                  }
                }
                if (this.filters.garantie_types) {
                  data.garantie = [];
                  for (let i in this.filters.garantie_types) {
                    let garantie = this.filters.garantie_types[i];
                    if (garantie.value) { data.garantie.push(garantie.id); }
                  }
                }
                if (this.filters.garantie_durations) {
                  data.duration = [];
                  for (let i in this.filters.garantie_durations) {
                    let duration = this.filters.garantie_durations[i];
                    if (duration.value) { data.duration.push(duration.id); }
                  }
                }
                if (this.filters.periods) {
                  data.periods = [];
                  for (let i in this.filters.periods) {
                    let periods = this.filters.periods[i];
                    if (periods.value) { data.periods.push(periods.id); }
                  }
                }
                return data;
            },
            parseDate(garanty) {
              if (garanty && garanty.created_at) {
                let day = garanty.datesParse.day_created,
                  month = garanty.datesParse.month_created,
                  year = garanty.datesParse.year_created;
                return day + "/" + month + '/' + year;
              }

              return ' - ';
            },
            parsePrice(garanty) {
              let price = garanty.price || 0;
              let assistance_price = garanty.assistance_price || 0;
              let full_price = price + assistance_price;
              return `${this.roundEURWithoutSymbol(full_price)} €`;
            },
            parseFullName(garanty) {
              if (this.isRepresentative()) {
                return (garanty && garanty.mechanic && garanty.mechanic.garage) ? garanty.mechanic.garage : ' - ';
              }
              else {
                return (garanty && garanty.client) ? garanty.client.first_name + ' ' + garanty.client.last_name : ' - ';
              }
            },
            parseTypeGaranty(garanty) {
              if (garanty && garanty.garantie_name) {
                return garanty.garantie_name;
              }
              else if (garanty && garanty.category) {
                switch (+garanty.category) {
                  case 2:
                    return 'Auto';
                  case 3:
                    return 'Moto';
                  case 1:
                    return this.parseTypeGarantyForDealers(garanty);
                }
              }

              return '';
            },
            parseCategoryGaranty(garanty) {
              if (garanty && garanty.category) {
                switch (+garanty.category) {
                  case 2:
                    return 'Auto';
                  case 3:
                    return 'Moto';
                  case 1:
                    return this.parseTypeGarantyForDealers(garanty);
                }
              }

              return '';
            },
            parseTypeGarantyForDealers (guaranty) {
              if (this.isDealer()) {
                return (guaranty.details.is_new.toLowerCase() === "oui") ? 'Garantie camping car neuf' : 'Garantie camping-car occasion';
              }
              return 'Camping car';
            },
        },
        mounted() {
            this.getGaranties();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Statistics/AdvanceStatsAssistance.vue